import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 750 500"
    {...props}
  >
    <path
      d="M475 200.84v44.09a14.39 14.39 0 0 0 14.45 14.14h158.07A14.45 14.45 0 0 0 662 244.63v-37.27l19.68-20.68-192.21-.6A14.52 14.52 0 0 0 475 200.84Z"
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="m638.66 212.8-143.49-.67.02-4.41 143.48.67-.01 4.41zM638.66 227.31l-143.49-.67.02-4.41 143.48.67-.01 4.41z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M608.07 210.72h4.41v56.77h-4.41z"
      style={{
        fill: "#e0e0e0",
      }}
      transform="rotate(-89.72 610.268 239.108)"
    />
    <path
      d="M205.47 425.61c22.11-15.45 27.12-44.12 26.25-69.9-.15-4.3.32-8.84-1.72-12.61s-6.82-6.36-10.68-4.54c-3.19 1.5-4.58 5.22-6.37 8.29a25.16 25.16 0 0 1-10.09 9.64c-2.74 1.42-6.13 2.29-8.83.8-3.72-2.05-4.15-7.18-4.13-11.46l.15-23.92c0-4.28 0-8.65-1.29-12.71s-4.27-7.83-8.34-9-9.1 1.2-10 5.39c-.36 1.74 0 3.55-.13 5.33s-.94 3.74-2.63 4.24-3.42-.71-4.7-2c-4.42-4.32-7.41-9.88-10.21-15.42s-5.52-11.2-9.53-15.91-9.55-8.45-15.68-8.8-12.66 3.44-14.2 9.46 2 12.15 5.79 17a95.61 95.61 0 0 0 19.89 19c1.35 1 2.81 2 3.33 3.57.92 2.86-1.78 5.69-4.59 6.63-3.19 1.06-6.66.73-10 1.12s-7 1.87-8.21 5c-1.76 4.37 1.9 9 5.5 12a82 82 0 0 0 24.22 14c3.14 1.15 6.46 2.16 9 4.37s4.07 6.06 2.54 9.07-5.47 4-8.77 3.37-6.24-2.4-9.39-3.58c-5.88-2.22-13.47-1.82-17.24 3.27-2.47 3.34-2.69 8-1.44 12s3.79 7.41 6.49 10.57c9.42 11.06 21.49 20 35.13 24.69s26.28 6 39.84 1.06"
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="M205.8 444.71a187.44 187.44 0 0 0-7-35.26 381.42 381.42 0 0 0-15.22-41.28q-2.29-5.39-4.54-10.62c-1.5-3.48-3-6.93-4.65-10.22A191.57 191.57 0 0 0 163.76 329c-3.67-5.67-7.35-10.92-10.84-15.8s-6.83-9.35-10-13.31a151.57 151.57 0 0 0-16.57-17.51c-2.11-1.91-3.8-3.34-5-4.29L120 277a2.86 2.86 0 0 0-.46-.34 3.49 3.49 0 0 0 .41.4l1.27 1.14c1.12 1 2.78 2.45 4.85 4.39a160.31 160.31 0 0 1 16.35 17.64c3.18 4 6.49 8.45 9.95 13.34s7.12 10.14 10.76 15.81a193 193 0 0 1 10.56 18.29c1.65 3.27 3.12 6.69 4.62 10.18l4.54 10.61a392.56 392.56 0 0 1 15.25 41.18 191.21 191.21 0 0 1 7.13 35.11"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M174.17 347.3a8 8 0 0 0 .42-1.82c.23-1.18.49-2.91.79-5 .61-4.26 1.24-10.17 1.92-16.69s1.39-12.41 2.06-16.65c.33-2.12.61-3.83.82-5a8.35 8.35 0 0 0 .24-1.85 8.56 8.56 0 0 0-.54 1.79c-.3 1.16-.67 2.87-1.07 5-.81 4.23-1.62 10.13-2.29 16.67l-1.69 16.7c-.21 2-.4 3.7-.54 5.06a8.74 8.74 0 0 0-.12 1.79Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M119.16 337a10.76 10.76 0 0 0 2.19.26c1.41.13 3.46.3 6 .59 5 .55 12 1.54 19.58 3s14.43 3.05 19.33 4.35c2.45.64 4.43 1.2 5.8 1.59a12.33 12.33 0 0 0 2.14.52 11.8 11.8 0 0 0-2-.82c-1.35-.47-3.3-1.12-5.75-1.83-4.87-1.44-11.7-3.14-19.33-4.59a192.27 192.27 0 0 0-19.66-2.75c-2.53-.22-4.59-.31-6-.33a11.87 11.87 0 0 0-2.3.01ZM198.14 408.44a3.15 3.15 0 0 0 .37-.67c.26-.54.57-1.2.94-2 .81-1.74 1.92-4.27 3.24-7.43 2.66-6.3 6.05-15.12 9.66-24.9s6.92-18.63 9.44-25l3-7.51c.32-.82.58-1.5.8-2a2.33 2.33 0 0 0 .23-.74 3.11 3.11 0 0 0-.37.68c-.26.53-.57 1.19-.94 2-.81 1.74-1.92 4.27-3.24 7.43-2.66 6.3-6.05 15.12-9.66 24.91s-6.92 18.62-9.44 25c-1.24 3.09-2.25 5.63-3 7.51-.32.82-.58 1.5-.8 2.05a2.41 2.41 0 0 0-.23.67ZM125 384.88a3.44 3.44 0 0 0 .73.29l2.12.72 7.83 2.53c6.61 2.15 15.7 5.21 25.75 8.61s19.18 6.39 25.84 8.4c3.32 1 6 1.79 7.9 2.29l2.17.57a3.49 3.49 0 0 0 .77.15 3.06 3.06 0 0 0-.73-.3l-2.12-.71-7.83-2.54c-6.61-2.14-15.71-5.21-25.75-8.61s-19.18-6.39-25.84-8.4c-3.32-1-6-1.79-7.9-2.29l-2.14-.59a2.61 2.61 0 0 0-.8-.12ZM256.48 155.21v34.17a11.2 11.2 0 0 1-11.19 11.2H122.77a11.2 11.2 0 0 1-11.19-11.2v-28.87l-15.25-16 148.93-.51a11.19 11.19 0 0 1 11.22 11.21Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="m129.64 164.72 111.18-.51-.01-3.42-111.18.51.01 3.42zM129.64 175.96l111.18-.51-.01-3.42-111.18.52.01 3.41z"
      style={{
        fill: "#fafafa",
      }}
    />
    <path
      d="M129.63 183.4h43.99v3.42h-43.99z"
      style={{
        fill: "#fafafa",
      }}
      transform="rotate(-.28 153.016 186.586)"
    />
    <rect
      width={258.1}
      height={370.4}
      x={252.6}
      y={150.57}
      rx={11.55}
      style={{
        fill: "#263238",
      }}
      transform="rotate(-90 381.65 335.77)"
    />
    <path
      d="M255.54 181.11h241.83v309.33H255.54z"
      style={{
        fill: "#fff",
      }}
      transform="rotate(-90 376.455 335.775)"
    />
    <circle
      cx={548.24}
      cy={335.77}
      r={9.9}
      style={{
        fill: "#455a64",
      }}
      transform="rotate(-76.77 548.277 335.77)"
    />
    <rect
      width={77.74}
      height={4.09}
      x={170.29}
      y={333.72}
      rx={1.22}
      style={{
        fill: "#455a64",
      }}
      transform="rotate(-90 209.16 335.77)"
    />
    <circle
      cx={288.66}
      cy={343.04}
      r={24.99}
      style={{
        fill: "#0345b7",
      }}
      transform="rotate(-56.65 288.634 343.023)"
    />
    <circle
      cx={288.66}
      cy={343.04}
      r={24.99}
      style={{
        fill: "#fff",
        opacity: 0.30000000000000004,
      }}
      transform="rotate(-56.65 288.634 343.023)"
    />
    <path
      d="M280 336.74c.94-.08 1.8 1 1.92 2.34s-.57 2.53-1.52 2.61-1.8-1-1.91-2.33.6-2.54 1.51-2.62ZM295.92 336.41c-.94 0-1.76 1-1.82 2.42s.67 2.51 1.62 2.55 1.77-1 1.82-2.41-.67-2.52-1.62-2.56ZM298.65 348c0 .29-4.66.53-10.4.53s-10.41-.24-10.41-.53 4.66-.54 10.41-.54 10.4.23 10.4.54ZM282 333.87c-.06.3-1.25.29-2.64.51s-2.52.58-2.67.32.9-1.12 2.51-1.37 2.8.26 2.8.54ZM300.43 335.08c-.18.24-1.26-.32-2.65-.74s-2.59-.57-2.62-.88 1.33-.64 2.93-.14 2.53 1.55 2.34 1.76Z"
      style={{
        fill: "#263238",
      }}
    />
    <circle
      cx={469.57}
      cy={340.97}
      r={25.9}
      style={{
        fill: "#0345b7",
      }}
      transform="rotate(-80.95 469.584 340.964)"
    />
    <circle
      cx={469.57}
      cy={340.97}
      r={25.9}
      style={{
        opacity: 0.30000000000000004,
      }}
      transform="rotate(-80.95 469.584 340.964)"
    />
    <path
      d="M460.63 334.44c1-.08 1.88 1 2 2.42s-.58 2.63-1.56 2.71-1.88-1-2-2.42.58-2.63 1.56-2.71ZM477.1 334.1c-1 0-1.83 1.08-1.89 2.5s.7 2.6 1.68 2.64 1.83-1.08 1.89-2.5-.69-2.6-1.68-2.64ZM479.93 346.1c-.11.14-1.19-.63-3-1.58a16.73 16.73 0 0 0-7.71-1.9 19.24 19.24 0 0 0-7.73 2c-1.88.92-3 1.62-3.09 1.48s.89-1 2.74-2.14a16.79 16.79 0 0 1 8.06-2.41 15.21 15.21 0 0 1 8.1 2.31c1.79 1.14 2.7 2.14 2.63 2.24ZM462.61 331.46c.09.11-.08.44-.51.81a4.19 4.19 0 0 1-2 1 3.84 3.84 0 0 1-2.25-.25c-.53-.24-.77-.52-.71-.65s1.35.13 2.77-.15 2.51-1 2.7-.76ZM481.78 332.72c0 .13-.24.38-.82.56a3.8 3.8 0 0 1-2.32-.08 4.67 4.67 0 0 1-1.91-1.27c-.38-.44-.52-.79-.42-.89s1.27.66 2.67 1.15 2.7.23 2.8.53Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m419.93 412.86 6-2.97 5.86 3.26-.98-6.63 4.91-4.56-6.61-1.12-2.82-6.08-3.1 5.94-6.65.8 4.68 4.79-1.29 6.57z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="m395.45 412.86 6-2.97 5.86 3.26-.98-6.63 4.91-4.56-6.61-1.12-2.82-6.08-3.1 5.94-6.65.8 4.68 4.79-1.29 6.57zM370.97 412.86l6-2.97 5.85 3.26-.97-6.63 4.91-4.56-6.61-1.12-2.82-6.08-3.1 5.94-6.65.8 4.68 4.79-1.29 6.57zM346.49 412.86l6-2.97 5.85 3.26-.97-6.63 4.91-4.56-6.61-1.12-2.82-6.08-3.1 5.94-6.65.8 4.68 4.79-1.29 6.57zM322.01 412.86l6-2.97 5.85 3.26-.97-6.63 4.91-4.56-6.61-1.12-2.82-6.08-3.1 5.94-6.65.8 4.68 4.79-1.29 6.57z"
      style={{
        fill: "#0345b7",
      }}
    />
    <path
      d="M436 265.51c0 .15-26.86.27-60 .27s-60-.12-60-.27 26.85-.26 60-.26 60 .12 60 .26ZM406.5 258.31c0 .15-13.26.27-29.62.27s-29.63-.12-29.63-.27 13.26-.27 29.63-.27 29.62.12 29.62.27Z"
      style={{
        fill: "#263238",
      }}
    />
    <circle
      cx={381.13}
      cy={335}
      r={34.12}
      style={{
        fill: "#0345b7",
      }}
      transform="rotate(-72.14 381.163 334.997)"
    />
    <path
      d="M369.36 326.4c1.29-.1 2.46 1.32 2.62 3.19s-.77 3.46-2.06 3.57-2.47-1.32-2.62-3.18.77-3.47 2.06-3.58ZM391.05 326c-1.29-.06-2.41 1.42-2.48 3.29s.91 3.43 2.2 3.48 2.41-1.42 2.49-3.29-.91-3.48-2.21-3.48ZM394.77 337.15c.06.06-.22.41-.77 1a19.45 19.45 0 0 1-2.56 2.31 18.22 18.22 0 0 1-4.51 2.47 15.91 15.91 0 0 1-6.26 1 18.26 18.26 0 0 1-6.15-1.42 26.26 26.26 0 0 1-4.53-2.37c-2.42-1.62-3.7-2.88-3.63-3s1.56.9 4 2.32a31.72 31.72 0 0 0 4.49 2.11 19.12 19.12 0 0 0 5.85 1.27 16.08 16.08 0 0 0 5.88-.85 20.36 20.36 0 0 0 4.41-2.16c1.16-.8 2.1-1.47 2.71-2s1.02-.73 1.07-.68ZM370.9 318.73c-.06.3-1.69.19-3.63.5s-3.46.9-3.61.63 1.29-1.35 3.45-1.68 3.89.27 3.79.55ZM398.37 320.32c-.19.24-1.63-.62-3.57-1.2s-3.61-.7-3.62-1 1.79-.68 3.94 0 3.44 1.99 3.25 2.2Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M366.92 334.7c.13 0 .35.33.38 1a3.9 3.9 0 0 1-.74 2.36 3.86 3.86 0 0 1-2 1.48c-.62.18-1 .09-1.05 0 0-.3 1.26-.74 2.16-2.06s.95-2.73 1.25-2.78ZM397.66 337.84c0 .13-.26.34-.79.38a3 3 0 0 1-1.94-.6 3 3 0 0 1-1.15-1.69c-.11-.52 0-.85.14-.86.3 0 .64 1 1.64 1.69s2.03.78 2.1 1.08Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M422.85 334.7s0-.23-.06-.69l-.13-2c0-.44-.05-.94-.08-1.48s-.18-1.13-.27-1.77-.21-1.33-.33-2.06a23.35 23.35 0 0 0-.55-2.32 40.46 40.46 0 0 0-4.7-11.24 42.16 42.16 0 0 0-10.73-12l-1.83-1.35c-.64-.42-1.31-.81-2-1.22s-1.33-.86-2.06-1.19l-2.19-1.05-1.11-.53-1.17-.42-2.38-.87c-.8-.27-1.65-.44-2.48-.66a19.65 19.65 0 0 0-2.55-.58 39 39 0 0 0-5.33-.62c-.91 0-1.83-.12-2.75-.1l-2.79.14c-.47 0-.94 0-1.41.09l-1.41.22c-.93.15-1.89.26-2.83.46a42.8 42.8 0 0 0-5.62 1.65 44.34 44.34 0 0 0-5.5 2.41c-.89.49-1.74 1.05-2.62 1.57-.43.28-.89.51-1.3.82l-1.24.93a48.18 48.18 0 0 0-4.78 4.06l-2.14 2.36-.54.6-.49.64-1 1.29-1 1.29-.85 1.39-.85 1.4-.42.7-.36.73-1.43 3-1.14 3.12a41.72 41.72 0 0 0 0 26.59c.39 1 .77 2.08 1.15 3.12s.95 2 1.43 3l.36.74.42.7.85 1.39.85 1.39 1 1.3 1 1.29.48.64.54.59 2.14 2.36a48.09 48.09 0 0 0 4.78 4.07l1.25.92c.41.32.87.55 1.3.83.88.52 1.73 1.08 2.62 1.57a46.58 46.58 0 0 0 11.12 4.06c.94.2 1.9.31 2.84.46l1.4.22c.47.06.94.06 1.41.09l2.79.14c.92 0 1.84-.07 2.75-.1a38.8 38.8 0 0 0 5.33-.62 21.45 21.45 0 0 0 2.55-.58c.84-.22 1.68-.4 2.49-.66l2.37-.87 1.17-.42 1.11-.53 2.19-1.05a23 23 0 0 0 2.06-1.19c.67-.41 1.35-.8 2-1.22l1.82-1.36a42.17 42.17 0 0 0 10.74-12 40.63 40.63 0 0 0 4.69-11.29 23.18 23.18 0 0 0 .55-2.31c.12-.73.23-1.42.33-2.06s.21-1.23.27-1.77.06-1 .08-1.48c.06-.87.1-1.54.13-2s.06-.69.06-.69v.69c0 .46-.05 1.14-.08 2 0 .45 0 1-.06 1.49s-.16 1.14-.24 1.78-.2 1.34-.31 2.08a23.69 23.69 0 0 1-.53 2.32 40.14 40.14 0 0 1-4.63 11.37 42.25 42.25 0 0 1-10.76 12.12l-1.84 1.38c-.64.43-1.32.82-2 1.24s-1.34.87-2.08 1.2l-2.2 1.07-1.12.57-1.18.43-2.39.88c-.82.28-1.67.45-2.51.68a22 22 0 0 1-2.58.6 39.49 39.49 0 0 1-5.39.63c-.91 0-1.84.13-2.77.12l-2.82-.14c-.48 0-1 0-1.43-.09l-1.42-.22c-.95-.15-1.92-.26-2.87-.46a45.93 45.93 0 0 1-5.69-1.66 45.26 45.26 0 0 1-5.56-2.43c-.91-.49-1.77-1.06-2.66-1.59a13.91 13.91 0 0 1-1.32-.83l-1.26-.94a47.74 47.74 0 0 1-4.84-4.1l-2.17-2.39-.55-.6-.49-.65-1-1.3-1-1.32-.86-1.4-.86-1.41-.43-.71-.36-.75-1.45-3c-.39-1.05-.77-2.11-1.16-3.16a42.28 42.28 0 0 1 0-26.92l1.16-3.16 1.45-3 .37-.75.43-.71.86-1.41.86-1.4 1-1.31 1-1.31.49-.65.54-.6c.73-.79 1.45-1.59 2.17-2.38a49.18 49.18 0 0 1 4.84-4.11l1.26-.94c.42-.31.88-.55 1.32-.83.89-.52 1.76-1.09 2.66-1.58a45.26 45.26 0 0 1 5.56-2.43 45.93 45.93 0 0 1 5.69-1.66c.95-.2 1.92-.31 2.87-.46l1.42-.22c.47-.06.95-.06 1.42-.09l2.82-.14c.94 0 1.86.08 2.78.12a39.49 39.49 0 0 1 5.39.63 24.74 24.74 0 0 1 2.58.59c.84.24 1.69.41 2.5.68l2.4.88 1.18.44 1.12.54 2.21 1.06c.74.34 1.39.82 2.07 1.21s1.36.81 2 1.24l1.84 1.38A42.25 42.25 0 0 1 417 313a40.21 40.21 0 0 1 4.64 11.34c.18.83.45 1.59.53 2.33s.21 1.43.31 2.08.19 1.23.24 1.78 0 1 .06 1.48c0 .88.06 1.55.08 2s-.01.69-.01.69Z"
      style={{
        fill: "#0345b7",
      }}
    />
    <path
      d="M221.79 214.86h309.33v15.43H221.79z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M231.77 222.15a2.09 2.09 0 1 1-2.09-2.09 2.09 2.09 0 0 1 2.09 2.09ZM238.71 222.15a2.09 2.09 0 1 1-2.09-2.09 2.09 2.09 0 0 1 2.09 2.09ZM245.66 222.15a2.09 2.09 0 1 1-2.09-2.09 2.1 2.1 0 0 1 2.09 2.09Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M497 277.68c0 .15-53.67.27-119.87.27s-119.88-.12-119.88-.27 53.67-.26 119.88-.26 119.87.12 119.87.26ZM497 283.63c0 .14-53.67.26-119.87.26s-119.88-.12-119.88-.26 53.67-.27 119.88-.27 119.87.12 119.87.27Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M339.7 208.35s-2.11-4.79-2.51-5.84c-1.07-2.87-8-22.1-6.33-25 7.67-13.47 13.62-23 28.75-23l26.73-.18s25.32-5.16 43.17 52.44Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="m283.32 213.17 35-7.54L359.46 184l.15-29.53c-6.17-1.7-18 2.58-39.25 13.41l-31.59 16.31a18.7 18.7 0 0 0-5.45 29Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M362.08 270.33c-.51-1.66-.16-2.73 2.26-1.91 5.34 1.79 10.11 1.2 11.27.17s.1-3-1.64-2.85a21.07 21.07 0 0 1-5.62-.78 13.74 13.74 0 0 1-4.19-1.77c-1.12-.71-2.08-1.38-2.93-2 0 0-4.93-3.56-6.47-6.42L337.87 262l2.72 8.46a9 9 0 0 0 5.71 6.54c4.83 1.57 12.51 1 12.51 1 1.41-.92 6.84 6.94 8.49 9.71s3.6 3.12 4.24 1.43c.43-1.16-4.4-9.77-6.08-12.48a32.81 32.81 0 0 1-3.38-6.35"
      style={{
        fill: "#b77153",
      }}
    />
    <path
      d="M350.64 278c0 .06-.42 0-1-.24a4.17 4.17 0 0 1-1.77-1.72 4.33 4.33 0 0 1-.55-2.41c.06-.64.26-1 .32-1a5.58 5.58 0 0 0 3 5.34ZM356 278.25c0 .06-.4 0-.94-.27a4.19 4.19 0 0 1-1.65-1.69 4.29 4.29 0 0 1-.52-2.31c.06-.61.23-1 .3-.93a7.89 7.89 0 0 0 .69 3 8.12 8.12 0 0 0 2.12 2.2Z"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="M282.32 212s53.62 61.62 53.55 60.6 24-19 24-19L307.34 191Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M314.84 199.92s.14.11.38.36l1 1.12 3.6 4.16c3 3.52 7.17 8.42 11.73 13.85s8.67 10.37 11.62 14l3.47 4.27.93 1.18c.2.27.31.42.29.43a2.05 2.05 0 0 1-.37-.36l-1-1.12c-.91-1-2.12-2.45-3.6-4.16-3-3.52-7.18-8.42-11.74-13.85s-8.66-10.37-11.62-14l-3.47-4.27c-.37-.47-.68-.86-.92-1.18a2.22 2.22 0 0 1-.3-.43ZM409.69 207a18.1 18.1 0 0 0 .64-4 11.81 11.81 0 0 0-3.5-8.64c-1.3-1.37-2.7-2.55-3.83-3.79a11.54 11.54 0 0 1-2.4-3.74 6.61 6.61 0 0 1-.44-3 2.76 2.76 0 0 1 .28-1.07 7.52 7.52 0 0 0 .51 3.9 12.08 12.08 0 0 0 2.41 3.55c1.12 1.19 2.52 2.35 3.85 3.75a12.25 12.25 0 0 1 2.89 4.62 11.84 11.84 0 0 1 .61 4.4 10.33 10.33 0 0 1-.57 2.94 3.54 3.54 0 0 1-.45 1.08Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M337.37 159.6s.27-.14.78-.37 1.3-.52 2.32-.84a20 20 0 0 1 3.84-.78 13.06 13.06 0 0 1 5.18.48 12.07 12.07 0 0 1 5.29 3.4A14 14 0 0 1 358 168a24.7 24.7 0 0 1 .51 8 17.38 17.38 0 0 1-3 8 22 22 0 0 1-6.41 5.69c-2.35 1.48-4.71 2.68-6.95 3.86l-11.91 6.26-8 4.17-2.2 1.11a4.27 4.27 0 0 1-.79.35 6.53 6.53 0 0 1 .74-.45l2.15-1.2 8-4.32 11.84-6.35c2.23-1.19 4.6-2.41 6.91-3.88a21.73 21.73 0 0 0 6.26-5.55 16.83 16.83 0 0 0 2.88-7.79 24.57 24.57 0 0 0-.47-7.8 13.62 13.62 0 0 0-3-6.29 11.61 11.61 0 0 0-5.08-3.34 13 13 0 0 0-5-.55 20.62 20.62 0 0 0-3.81.69c-1 .29-1.81.55-2.34.74a4.09 4.09 0 0 1-.96.25Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M320.74 205.57c-.18.05-.62-3.54-3-7.15s-5.42-5.51-5.3-5.65a6.87 6.87 0 0 1 2 1.22 17.18 17.18 0 0 1 6 9.28 6.76 6.76 0 0 1 .3 2.3Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M399.54 198.87a6.48 6.48 0 0 1-1.14.31 11.61 11.61 0 0 1-3.38.15 12.56 12.56 0 0 1-5.08-1.67 11.69 11.69 0 0 1-4.69-5.27 12.43 12.43 0 0 1-.65-8.51 7 7 0 0 1 2.83-3.92 3.51 3.51 0 0 1 2.56-.53 3.78 3.78 0 0 1 2.22 1.48 12.38 12.38 0 0 1 1.2 10.67 12.66 12.66 0 0 1-3 5 11.57 11.57 0 0 1-5.21 3 11.92 11.92 0 0 1-11.2-2.68 11.69 11.69 0 0 1-3.35-10.16 10.13 10.13 0 0 1 2-4.7 5.09 5.09 0 0 1 2-1.53 3.22 3.22 0 0 1 2.46 0 4.58 4.58 0 0 1 2.61 3.64 7.68 7.68 0 0 1-.81 4.08 19.55 19.55 0 0 1-4.26 5.68 20.19 20.19 0 0 1-4.37 3.09 18.85 18.85 0 0 1-3.12 1.31c-.36.12-.65.18-.84.23a1.18 1.18 0 0 1-.3.06 1 1 0 0 1 .28-.11c.19-.07.47-.15.83-.29a21 21 0 0 0 3.05-1.38 20.67 20.67 0 0 0 4.27-3.13 19.4 19.4 0 0 0 4.12-5.61 7.4 7.4 0 0 0 .74-3.88 4.18 4.18 0 0 0-2.37-3.28 2.78 2.78 0 0 0-2.12 0 4.59 4.59 0 0 0-1.8 1.4 9.56 9.56 0 0 0-1.92 4.49 11.19 11.19 0 0 0 3.22 9.7A11.39 11.39 0 0 0 385 199a10.92 10.92 0 0 0 5-2.8 12.11 12.11 0 0 0 2.91-4.75 13 13 0 0 0 .59-5.37 10.61 10.61 0 0 0-.55-2.57 7.41 7.41 0 0 0-1.12-2.27 3.34 3.34 0 0 0-1.94-1.31 3 3 0 0 0-2.21.46A6.49 6.49 0 0 0 385 184a12.07 12.07 0 0 0 .56 8.23 11.36 11.36 0 0 0 4.51 5.17 12.34 12.34 0 0 0 4.95 1.72 13.67 13.67 0 0 0 4.52-.25Z"
      style={{
        fill: "#fafafa",
      }}
    />
    <path
      d="M403.58 138.87a12.12 12.12 0 0 1-2.39-4.75 3.18 3.18 0 0 1-.06-1.73 1.32 1.32 0 0 1 1.29-1c.6 0 1 .61 1.33 1.12a25.82 25.82 0 0 1 2.46 4.68 3.54 3.54 0 0 1 .29 1.42 1.43 1.43 0 0 1-.69 1.21 1.48 1.48 0 0 1-1.51-.2 4.47 4.47 0 0 1-1-1.21"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="m406.15 137.76-2.64-5.54a4.45 4.45 0 0 1-.55-1.72 1.5 1.5 0 0 1 .85-1.48 1.48 1.48 0 0 1 1.46.38 4.18 4.18 0 0 1 .89 1.3l1.25 2.43a7.78 7.78 0 0 1 .82 2.06 2.66 2.66 0 0 1-.41 2.13 1.63 1.63 0 0 1-2 .47"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="M394.4 154.89s-3.68-4.77-4-7.28 2.75-7 9.36-8a16.16 16.16 0 0 0 6.8-2.32 2.13 2.13 0 0 0 .77-2.58c-.87-2.11-2.43-6-2.31-6.55.31-1.35 1.19-1.32 3.47 2s4.93 6.74 4.42 8.28-8.57 6.31-8.57 6.31l2.2 3.55Z"
      style={{
        fill: "#b77153",
      }}
    />
    <path
      d="m416.26 203.93-25.37-49.71 16.34-9.15 34.32 54.4s1.81 3.48 4.34 7.55h-28.77"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M407 145.07s-.09.08-.28.2l-.86.52-3.28 1.91-11.8 6.72.09-.3c2.47 5 5.68 10.85 8.91 17.18 4.81 9.35 9 17.92 11.9 24.16 1.46 3.12 2.62 5.66 3.41 7.41.37.85.67 1.52.89 2a3.64 3.64 0 0 1 .28.72 3.78 3.78 0 0 1-.38-.68c-.24-.5-.57-1.16-1-2l-3.56-7.34c-3-6.19-7.22-14.73-12-24.08-3.23-6.32-6.42-12.15-8.85-17.21l-.09-.2.19-.11 11.89-6.55 3.35-1.81.89-.46a1.17 1.17 0 0 1 .3-.08ZM339.7 208.35a30.73 30.73 0 0 1-4.23-11.68c.16 0 .85 2.66 2 5.87s2.37 5.74 2.23 5.81ZM395.58 135.07a10 10 0 0 0 11.83-15.17c5.73-1.45 9.3-8.06 8.14-13.86s-6.33-10.32-12.11-11.57a13 13 0 0 0-6.7.17 8.24 8.24 0 0 0-5 4.29"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M394.77 122.11c0 .06-.74.2-1.95.83a8.61 8.61 0 0 0-3.83 4.12 8.48 8.48 0 0 0 .64 8.06 8.08 8.08 0 0 0 1.6 1.82 7.94 7.94 0 0 0 2.14 1.33 8.4 8.4 0 0 0 9.69-2.21 8.15 8.15 0 0 0 1.35-2.13 8.29 8.29 0 0 0 .65-2.33 8.56 8.56 0 0 0-8.16-9.6c-1.37-.05-2.12.17-2.13.1a2.09 2.09 0 0 1 .54-.15 7.26 7.26 0 0 1 1.59-.16 8.77 8.77 0 0 1 8 5.22 8.81 8.81 0 0 1 .69 4.64 7.9 7.9 0 0 1-.67 2.47 8.22 8.22 0 0 1-1.42 2.27 8.88 8.88 0 0 1-10.29 2.35 8.5 8.5 0 0 1-2.26-1.43 8.27 8.27 0 0 1-1.68-1.93 9 9 0 0 1-1.39-4.48 8.76 8.76 0 0 1 4.89-8.15 6.82 6.82 0 0 1 1.51-.55 2.2 2.2 0 0 1 .49-.09Z"
      style={{
        fill: "#0345b7",
      }}
    />
    <path
      d="M399.11 106.35a9.83 9.83 0 0 0 4.62-18.17 12.21 12.21 0 0 0-18.23-14.29 16.2 16.2 0 0 0-30 4.8 15.66 15.66 0 0 0-20.1 21.25 12.13 12.13 0 0 0 2.06 24.18 10.7 10.7 0 0 0 16.22 12 11.72 11.72 0 0 0 21.06-2.42"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M387.07 153.27c.21-4.87.47-9.28.47-9.28s10.89-1.37 11.36-12.48-.64-36.69-.64-36.69l-20-9.62-21.56 17.36 3.38 51a13.54 13.54 0 0 0 14.13 12.62 13.52 13.52 0 0 0 12.86-12.91Z"
      style={{
        fill: "#b77153",
      }}
    />
    <path
      d="M397.73 113.84c-.18.19-1.22-.68-2.71-.74s-2.6.7-2.75.5.1-.43.58-.79a3.52 3.52 0 0 1 2.21-.63 3.58 3.58 0 0 1 2.15.83c.45.4.6.75.52.83ZM381.21 113.84c-.18.19-1.21-.68-2.71-.74s-2.59.7-2.75.5.1-.43.58-.79a3.52 3.52 0 0 1 2.21-.63 3.58 3.58 0 0 1 2.15.83c.45.4.6.75.52.83ZM386.81 125.05a8.9 8.9 0 0 1 2.43-.37c.38 0 .74-.1.81-.37a2.23 2.23 0 0 0-.23-1.22q-.52-1.5-1.08-3.15c-1.5-4.49-2.57-8.17-2.4-8.23s1.51 3.53 3 8l1 3.17a2.62 2.62 0 0 1 .17 1.61 1 1 0 0 1-.64.57 2.19 2.19 0 0 1-.64.07 9.11 9.11 0 0 1-2.42-.08Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M387.54 144a26.48 26.48 0 0 1-14.41-4.72s3.39 8.09 14.22 7.45Z"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="M372.08 85.82a14.68 14.68 0 0 0 .2 17c1.62 2.12 4.06 3.85 6.73 3.75s5.25-2.62 4.68-5.23a5.52 5.52 0 1 0 10.58.19 10.08 10.08 0 0 0 1.25 3.4 3.37 3.37 0 0 0 3.07 1.62c1.67-.22 2.64-2 3-3.67A15.07 15.07 0 0 0 397.34 89a18.22 18.22 0 0 0-13.88-4.87 23.19 23.19 0 0 0-13.63 6"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M373.49 89.74a25.76 25.76 0 0 1 2.24 10 13.37 13.37 0 0 1-3.6 9.36 9.09 9.09 0 0 1-9.45 2.27 10.52 10.52 0 0 1-1.38 8.87c-1.86 2.47-5.52 3.65-8.23 2.16-2.46-1.34-3.52-4.32-3.86-7.1a22.74 22.74 0 0 1 24.73-25.37"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M359.75 116.21c-1.48-.92-3.5-.17-4.68 1.12a6.39 6.39 0 0 0 6.36 10.48"
      style={{
        fill: "#b77153",
      }}
    />
    <path
      d="M359.41 124.48c0 .06-.49.13-1.26-.08a3.37 3.37 0 0 1-2.28-2 2.47 2.47 0 0 1 .06-1.78 2.67 2.67 0 0 1 .92-1.09c.69-.45 1.21-.44 1.22-.38s-.45.21-1 .68a2.19 2.19 0 0 0-.71 2.4 3.34 3.34 0 0 0 1.91 1.85c.73.25 1.15.32 1.14.4Z"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="M382.13 109.21c-.14.43-1.77.27-3.7.36s-3.54.33-3.71-.09 1.4-1.43 3.65-1.51 3.91.83 3.76 1.24ZM397.69 108.9c-.17.15-.5 0-.89-.05a3.86 3.86 0 0 0-1.36-.08c-.58 0-1.22.16-1.71.15s-.83-.11-.89-.33.16-.48.57-.76a4.35 4.35 0 0 1 1.89-.66 2.52 2.52 0 0 1 2.15.76c.37.45.4.83.24.97Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M384.22 127.89a3.38 3.38 0 0 1 2.81-.4 2.1 2.1 0 0 1 1.39 2.3 2.24 2.24 0 0 1-.9 1.28 2.91 2.91 0 0 1-2.31.56 2.27 2.27 0 0 1-1.73-1.57 1.86 1.86 0 0 1 .91-2.08"
      style={{
        fill: "#995037",
      }}
    />
    <path
      d="M389.68 129.08s-.36.31-1.07.46a4.79 4.79 0 0 1-2.82-.27 4.9 4.9 0 0 1-2.18-1.81c-.4-.61-.48-1.06-.42-1.09s.28.35.72.87a5.78 5.78 0 0 0 2.08 1.54 5.69 5.69 0 0 0 2.56.39c.68-.05 1.1-.17 1.13-.09Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M367.13 134.38c-.07 0 0-.78-.38-2.1a8.58 8.58 0 0 0-3.16-4.64 8.42 8.42 0 0 0-3.57-1.56 8.6 8.6 0 0 0-4.43.38 8 8 0 0 0-2.13 1.16 7.72 7.72 0 0 0-1.77 1.79 8.38 8.38 0 0 0 0 9.93 7.72 7.72 0 0 0 1.77 1.79 8 8 0 0 0 2.13 1.16 8.54 8.54 0 0 0 11.16-5.82c.35-1.32.31-2.1.38-2.09a3.33 3.33 0 0 1 0 .55 6.86 6.86 0 0 1-.19 1.59 8.61 8.61 0 0 1-3.14 4.89 8.8 8.8 0 0 1-3.72 1.7 8.91 8.91 0 0 1-4.68-.36 8.38 8.38 0 0 1-2.26-1.21 8.27 8.27 0 0 1-1.89-1.89 8.83 8.83 0 0 1 0-10.55 8.27 8.27 0 0 1 1.89-1.89 8.38 8.38 0 0 1 2.26-1.21 8.78 8.78 0 0 1 8.4 1.34 8.61 8.61 0 0 1 3.14 4.89 6.86 6.86 0 0 1 .19 1.59 3.42 3.42 0 0 1 0 .56Z"
      style={{
        fill: "#0345b7",
      }}
    />
    <path
      d="M397.68 84.66a.82.82 0 0 1 .28.07 2.14 2.14 0 0 1 .7.45 3.23 3.23 0 0 1 .89 2.92 4.18 4.18 0 0 1-3.46 3.06 8.69 8.69 0 0 1-5.86-1.4l-2.06-1.19 2.26.74a2.45 2.45 0 0 1 1.57 1.76 3.11 3.11 0 0 1-.32 2.39 3.33 3.33 0 0 1-2 1.44 4.73 4.73 0 0 1-2.53-.06 8.63 8.63 0 0 1-4.36-3.76L381.27 89l1.84 1.79a4 4 0 0 1 1 3.78 4.1 4.1 0 0 1-2.22 2.81 5.36 5.36 0 0 1-5.69-.69 6.79 6.79 0 0 1-2.2-3.25 6.87 6.87 0 0 1-.24-1 1.94 1.94 0 0 1 0-.36c.05 0 .11.48.43 1.31a6.91 6.91 0 0 0 2.19 3 5.06 5.06 0 0 0 5.29.55 3.67 3.67 0 0 0 1.95-2.52 3.53 3.53 0 0 0-.87-3.3l.39-.33a8.2 8.2 0 0 0 4.07 3.54 3.52 3.52 0 0 0 4-1.14c.72-1.18.29-3-.93-3.41l.2-.45a8.35 8.35 0 0 0 5.52 1.43 3.87 3.87 0 0 0 3.26-2.76 3.16 3.16 0 0 0-.71-2.75 3.8 3.8 0 0 0-.87-.59ZM371 102.53s0 .07-.13.19a4.62 4.62 0 0 1-.47.5 6.52 6.52 0 0 1-2.23 1.33 6.36 6.36 0 0 1-4 .06 6.68 6.68 0 0 1-4-3.43l.42-.06a6.47 6.47 0 1 1-10.88-5.68l.35.37a6.63 6.63 0 0 1-4.2 1.53 7.25 7.25 0 0 1-3.95-1.08 6 6 0 0 1-2.37-2.78 7.06 7.06 0 0 1-.49-3.09 6.8 6.8 0 0 1 1.64-4.06 4.34 4.34 0 0 1 1.22-1s-.45.34-1.08 1.13a6.93 6.93 0 0 0-1.46 4 6.77 6.77 0 0 0 .53 2.92 5.64 5.64 0 0 0 2.24 2.55 6.79 6.79 0 0 0 3.71 1 6.25 6.25 0 0 0 3.88-1.42l.34.37a6.19 6.19 0 0 0-1.27 6.73 6.12 6.12 0 0 0 6.68 3.39 6.22 6.22 0 0 0 4.68-4.87l.11-.7.31.64a6.36 6.36 0 0 0 3.68 3.28 6.1 6.1 0 0 0 3.85 0 6.66 6.66 0 0 0 2.22-1.18c.48-.42.67-.66.67-.64ZM351.21 120.31a2.5 2.5 0 0 1-.87.52 5.89 5.89 0 0 1-2.77.43 5.71 5.71 0 0 1-3.81-1.86 6.17 6.17 0 0 1-1.51-5.13l.46.2a10.28 10.28 0 0 1-3.75 3.07 8 8 0 0 1-3.65.77 7.31 7.31 0 0 1-3.35-.92 5.93 5.93 0 0 1-3.19-4.73 5.66 5.66 0 0 1 1-3.75 4.11 4.11 0 0 1 .75-.76 1 1 0 0 1 .32-.2s-.39.34-.9 1.08a5.64 5.64 0 0 0-.82 3.6 5.55 5.55 0 0 0 3.08 4.37 7.17 7.17 0 0 0 6.53.09 9.84 9.84 0 0 0 3.57-2.89l.65-.84-.19 1a5.77 5.77 0 0 0 1.33 4.74 5.49 5.49 0 0 0 3.52 1.84 6.22 6.22 0 0 0 2.67-.27c.6-.21.91-.39.93-.36ZM407.84 98.65a3.45 3.45 0 0 1 .22 1.85 6.67 6.67 0 0 1-5.85 6.11 3.31 3.31 0 0 1-1.85-.14c0-.09.71 0 1.79-.23a6.87 6.87 0 0 0 5.53-5.79c.18-1.09.07-1.79.16-1.8ZM414 109.12a1.91 1.91 0 0 1 .25.76 4.33 4.33 0 0 1-.21 2.19 3.42 3.42 0 0 1-2.42 2.23 3.49 3.49 0 0 1-2-.18 2.79 2.79 0 0 1-1.59-1.54l.5-.17a3.51 3.51 0 0 1 .13 1 4 4 0 0 1-2.51 3.56 3.32 3.32 0 0 1-2 .09 3.82 3.82 0 0 1-1.5-.83 3.59 3.59 0 0 1-1.21-2.1c-.09-.57 0-.89 0-.88s0 .31.17.84a3.74 3.74 0 0 0 1.25 1.85 3.12 3.12 0 0 0 3.08.57 3.53 3.53 0 0 0 2.15-3.11 2.71 2.71 0 0 0-.11-.82l.51-.17a2.71 2.71 0 0 0 3 1.44 3.08 3.08 0 0 0 2.18-1.89 4.57 4.57 0 0 0 .35-2c-.02-.56-.11-.83-.02-.84Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M383.46 124c.07 0 .11.23 0 .57a2.35 2.35 0 0 1-2 1.64c-.35 0-.56-.06-.55-.13s.77-.22 1.45-.81.95-1.27 1.1-1.27ZM669.18 464.82c0 .15-129 .26-288.12.26S92.9 465 92.9 464.82s129-.26 288.16-.26 288.12.12 288.12.26ZM270.4 41.62a6.65 6.65 0 0 1-.7.09l-2 .17a22.17 22.17 0 0 0-3.28.47c-.65.14-1.36.2-2.08.42s-1.5.44-2.31.67a38.51 38.51 0 0 0-11 5.61 39.23 39.23 0 0 0-10.73 12.22 42 42 0 0 0-5.09 24.34c.06.92.26 1.83.39 2.76a20.92 20.92 0 0 0 .56 2.77 39.13 39.13 0 0 0 4.3 10.86 38.61 38.61 0 0 0 18.43 16.37 35.76 35.76 0 0 0 12.9 2.75A34.79 34.79 0 0 0 283.2 119l1.31-.5.17-.06.16.07 19 9.38-.55.49-6.06-18.09-.07-.23.16-.17a40.28 40.28 0 0 0 9.73-16.6 41.43 41.43 0 0 0 1.24-17.57 40.41 40.41 0 0 0-13.78-25.18 42 42 0 0 0-9.35-5.8 40.57 40.57 0 0 0-7.87-2.38l-2.94-.46-2.17-.13-1.33-.09a2.23 2.23 0 0 1-.45-.05 1.91 1.91 0 0 1 .45 0h1.33l2.19.06 3 .41a39.71 39.71 0 0 1 8 2.29 41.25 41.25 0 0 1 9.51 5.78 40.5 40.5 0 0 1 8.83 10.42 41.1 41.1 0 0 1 5.29 15 42 42 0 0 1-1.2 17.87 40.88 40.88 0 0 1-9.87 16.94l.07-.4c2 5.8 4 11.85 6.08 18.08l.31.91-.86-.42-19-9.37h.33l-1.34.51a35.35 35.35 0 0 1-13.71 2.13 36.46 36.46 0 0 1-13.18-2.81 39.37 39.37 0 0 1-18.77-16.74 39.79 39.79 0 0 1-4.37-11 19.51 19.51 0 0 1-.55-2.82c-.13-.94-.34-1.86-.39-2.8a40.92 40.92 0 0 1-.14-5.52A42.41 42.41 0 0 1 234 69.84a41.66 41.66 0 0 1 3.78-8.84 39.48 39.48 0 0 1 11-12.31 38.12 38.12 0 0 1 11.15-5.54l2.35-.64a20.75 20.75 0 0 1 2.09-.38 20.39 20.39 0 0 1 3.31-.4l2.05-.1Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M279.34 76.5h-2.77l-6.14-8.35-.06-5.53s-4.28-.21-3.7 7 0 5.39 0 5.39-9.08.14-9.83.94c-.54.58-.69 9.61-.72 14.5A5.3 5.3 0 0 0 260 95.8a4.17 4.17 0 0 0 1 .12c2.27 0 13.82-2 13.82-2l4.79-.06ZM287.25 74.89l-1.49 18.95-4.74.06-.21-18.55 6.44-.46z"
      style={{
        fill: "#0345b7",
      }}
    />
  </svg>
);
export default SvgComponent;
